<!-- <template>
  <v-container>
    <div class="tituloOnco tituloEscritorio">
      <div class="headerBack">
        <div style="display: flex; justify-content: center; gap: 47%">
          <div style="margin-top: 1%;">
            <img :src="logoSouthbrigde" alt="Southbrigde" >
          </div>
          <div style="margin-top: 2%;" class="textHeaderOnco">
            SEGURO ONCOLÓGICO IRAM
          </div>
        </div>
      </div>
      
    </div>

    <div class="tituloOnco tituloMobile">
      <div class="headerBack">
        <div  class="headerFlex">
          <div style="margin-top: 1%;">
            <img :src="logoSouthbrigde" alt="Southbrigde" >
          </div>
          <div style="margin-top: 2%;" class="textHeaderOnco">
            SEGURO ONCOLÓGICO IRAM
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template> -->
<template>
  <v-container>
    <!-- Imagen para escritorio -->
    <div class="tituloOnco tituloEscritorio">
      <img :src="barraFondo" alt="Imagen Escritorio">
    </div>

    <!-- Imagen para móvil -->
    <div class="tituloOnco tituloMobile">
      <img :src="barraFondoMobile" alt="Imagen Móvil">
    </div>
  </v-container>
</template>

<script>
// import barraFondo from '@/assets/images/HeaderIram.png'; 
// import barraFondoMobile from '@/assets/images/barraFondoMobile.png';
import barraFondo from '@/assets/images/barraFondo2.svg'; 
import barraFondoMobile from '@/assets/images/barraFondoMobile.svg'; 
import logoSouthbrigde from '@/assets/images/newLogo.png';


export default {
  name: "Titulo",
  data: () => {
    return {
      barraFondo,
      barraFondoMobile,
      logoSouthbrigde
    };
  },
  mounted() { },
};
</script>

<style lang="scss">
.v-container {
  justify-content: center;
  align-items: center;
  /* Agregamos alineación vertical al centro */
}
@media (min-width: 1264px) {
    .container {
        max-width: 97%;
    }
}

/* Estilo principal de la barra */
/* Barra común */
.tituloOnco {
  display: none; /* Ocultar por defecto */
  justify-content: center;
  max-width: 100%;
  overflow: hidden; 
}

/* Imagen de escritorio: mostrar solo en pantallas grandes */
@media (min-width: 601px) {
  .tituloEscritorio {
    display: flex; /* Mostrar en escritorio */
  }
}

.tituloOnco img {
  max-width: 102%;
  height: auto; 
  object-fit: contain;
}

/* Imagen de móvil: mostrar solo en pantallas pequeñas */
@media (max-width: 600px) {
  .tituloMobile {
    display: flex; /* Mostrar en móvil */
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 50px;
  }

  .tituloMobile img {
    width: 100%;
    height: 127px;
    margin-top: 13%;
  }
}
</style>